import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";

import userService from "../../app/services/user.service";
import Card from "../../UI/Card/Card";
import Graybg from "../../UI/Graybg";
import Loader from "../../UI/loader/loader";
import SecBTN from "../../UI/SecBTN";
import Toast from "../../UI/Toast/Toast";

const PaperCorrectionList = () => {
  const [loading, setLoading] = useState(false);
  const [paperList, setPaperList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [allFacultyList, setAllFacultyList] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [selectedPaper, setSelectedPaper] = useState(0);
  const [selectedSubject, setSelectedSubject] = useState(0);
  const [selectedFaculty, setSelectedFaculty] = useState(0);
  const [correctionType, setCorrectionType] = useState(0);
  const [correctionReason, setCorrectionReason] = useState(0);

  const paperOptions = paperList.map((item) => ({
    value: item.paper_id,
    label: item.paper_name + "(" + item.paper_id + ")",
  }));
  const selectedPaperData = paperList.find(
    (paper) => paper.paper_id === selectedPaper
  );

  const subjectOptions = (() => {
    // No paper selected → show all subjects
    if (!selectedPaperData) {
      return subjectList.map((item) => ({
        value: item.sub_id,
        label: item.sub_name,
      }));
    }

    // Paper selected → show only subjects of that paper
    try {
      const parsedSubjects = JSON.parse(selectedPaperData.subjects);

      const uniqueSubjects = [];
      const seen = new Set();

      parsedSubjects.forEach((item) => {
        if (!seen.has(item.sub_id)) {
          seen.add(item.sub_id);
          uniqueSubjects.push({
            value: item.sub_id,
            label: item.sub_name,
          });
        }
      });

      return uniqueSubjects;
    } catch (err) {
      console.log(err);
      return [];
    }
  })();

  const facultyOptions = allFacultyList.map((item) => ({
    value: item.user_id,
    label: item.user_name,
  }));

  const correctionTypeOptions = [
    { value: 1, label: "Answer Correction" },
    { value: 2, label: "Question Error" },
    { value: 3, label: "Bonus" },
  ];

  const correctionReasonOptions = [
    { value: 1, label: "Faculty Paper not check properly" },
    { value: 2, label: "SMD Operator mistake" },
    { value: 3, label: "Out of Syllabus" },
    { value: 4, label: "No correct Option" },
  ];

  useEffect(() => {
    setLoading(true);

    Promise.all([
      userService.getPaperList(),
      userService.getSubjectList(),
    ])
      .then(([paperRes, subjectRes]) => {
        setPaperList(paperRes?.data || []);
        setSubjectList(subjectRes?.data?.data || []);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Unable to load filter data.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  useEffect(() => {
    const fetchFaculty = async () => {
      try {
        let response;

        if (selectedSubject || selectedPaper) {
          const payload = {
            sub_id: selectedSubject,
            paper_id: selectedPaper || 0,
          };

          response = await userService.getFacultyList(payload);

          setAllFacultyList(response?.data?.data || []);
        } else {
          response = await userService.getUserList();

          const activeFaculty =
            response?.data?.data?.filter((faculty) => faculty.active == 1) || [];

          setAllFacultyList(activeFaculty);
        }
      } catch (err) {
        console.log(err);
        toast.error("Unable to load faculty list.");
      }
    };

    fetchFaculty();
  }, [selectedSubject, selectedPaper]);

  const getTableRows = (responseData) => {
    if (Array.isArray(responseData)) return responseData;
    if (Array.isArray(responseData?.data)) return responseData.data;
    if (Array.isArray(responseData?.result)) return responseData.result;
    if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
    return [];
  };

  const searchHandler = () => {
    setLoading(true);
    const body = {
      paper_id: selectedPaper || 0,
      sub_id: selectedSubject || 0,
      faculty_id: selectedFaculty || 0,
      correction_type_id: correctionType,
      correction_reason_type_id: correctionReason,
    };

    userService
      .getPaperErrorList(body)
      .then((res) => {
        const rows = getTableRows(res);
        setTableData(rows);
      })
      .catch((err) => {
        console.log(err);
        setTableData([]);
        toast.error("Unable to load paper correction list.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getCellValue = (row, keys) => {
    for (let i = 0; i < keys.length; i += 1) {
      const value = row?.[keys[i]];
      if (value !== undefined && value !== null && value !== "") return value;
    }
    return "-";
  };
  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();

    return `${day}-${month}-${year}`;
  };



  return (
    <div className="section">
      {loading && <Loader />}
      <Toast />

      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>Paper Correction List</h4>
          <Breadcrumb>
            <Breadcrumb.Item active>Paper Correction List</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <Graybg>
        <Card className="mb-4">
          <Row className="g-3">
            <Col md={4}>
              <Form.Label>Select Paper</Form.Label>
              <Select
                options={paperOptions}
                value={paperOptions.find((item) => item.value === selectedPaper) || null}
                onChange={(selected) => {
                  setSelectedPaper(selected?.value || 0);
                  setSelectedSubject(0);
                  setSelectedFaculty(0);
                }}
                placeholder="Select Paper"
                isSearchable
                isClearable
              />
            </Col>

            <Col md={4}>
              <Form.Label>Subject</Form.Label>
              <Select
                options={subjectOptions}
                value={subjectOptions.find((item) => item.value === selectedSubject) || null}
                onChange={(selected) => {
                  setSelectedSubject(selected?.value || 0);
                }}
                placeholder="Select Subject"
                isSearchable
                isClearable
              />
            </Col>

            <Col md={4}>
              <Form.Label>Paper Correction</Form.Label>
              <Select
                options={correctionTypeOptions}
                value={
                  correctionTypeOptions.find((item) => item.value === correctionType) || null
                }
                onChange={(selected) => {
                  setCorrectionType(selected?.value || 0);
                }}
                placeholder="Select Correction Type"
                isSearchable
                isClearable
              />
            </Col>

            <Col md={4}>
              <Form.Label>Reason of Correction</Form.Label>
              <Select
                options={correctionReasonOptions}
                value={
                  correctionReasonOptions.find((item) => item.value === correctionReason) || null
                }
                onChange={(selected) => {
                  setCorrectionReason(selected?.value || 0);
                }}
                placeholder="Select Reason"
                isSearchable
                isClearable
              />
            </Col>

            <Col md={4}>
              <Form.Label>Faculty Name</Form.Label>
              <Select
                options={facultyOptions}
                value={facultyOptions.find((item) => item.value === selectedFaculty) || null}
                onChange={(selected) => {
                  setSelectedFaculty(selected?.value || 0);
                }}
                placeholder="Select Faculty"
                isSearchable
                isClearable
              />
            </Col>

            <Col md={12} className="d-flex justify-content-center mt-3">
              <SecBTN className="sec-btn1 px-4" onClick={searchHandler}>
                Search
              </SecBTN>
            </Col>
          </Row>
        </Card>

        <div className="table-responsive mb-3">
          <table className="table table-bordered mt-2 mb-0">
            <thead>
              <tr>
                <th>S.No.</th>
                {/* <th>Paper ID</th> */}
                <th>Subject</th>
                <th>Paper Name</th>
                <th>Class</th>
                <th>Batch</th>
                <th>No. of Question</th>

                <th>Faculty Name</th>

                <th>Request Date</th>
                <th>Submission Date</th>
                <th>Finalization Date</th>

                <th>Exam Date</th>
                <th>Paper Correction</th>
                <th>Reason for Correction</th>
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((row, index) => (
                  <tr key={row.id || row.paper_correction_id || index}>
                    <td>{index + 1}</td>
                    {/* <td>{getCellValue(row, ["paper_id"])}</td> */}
                    <td>{getCellValue(row, ["sub_name"])}</td>
                    <td>{getCellValue(row, ["paper_name"])}({getCellValue(row, ["paper_id"])})</td>
                    <td>{getCellValue(row, ["class"])}</td>
                    <td>{getCellValue(row, ["batch_name"])}</td>
                    <td>{getCellValue(row, ["no_of_qus"])}</td>
                    <td>{getCellValue(row, ["faculty_name"])}</td>
                    <td>{formatDate(getCellValue(row, ["request_date"]))}</td>
                    <td>{formatDate(getCellValue(row, ["submission_date"]))}</td>
                    <td>{formatDate(getCellValue(row, ["finalization_date"]))}</td>
                    <td>{formatDate(getCellValue(row, ["exam_date"]))}</td>
                    <td>{getCellValue(row, ["paper_correction"])}</td>
                    <td>{getCellValue(row, ["reason_correction"])}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={13} className="text-center">
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Graybg>
    </div>
  );
};

export default PaperCorrectionList;